import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss'
})
export class CustomToastComponent implements OnInit {
  
  localToastId: string = 'globalToast';
  
  constructor(
    public _toast: ToastService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Establecer el ID local una vez al inicializar
    this.localToastId = this._toast.toastId;
    
    // Suscribirse a cambios en el toastId
    this._toast.toastIdChanged.subscribe((newId: string) => {
      // Actualizar el ID local en el próximo tick
      setTimeout(() => {
        this.localToastId = newId;
        this.cdr.markForCheck();
      }, 0);
    });
  }

}
